import React, { useState, useEffect, useRef } from "react"
import { Container, Row, Col, Button, Card, CardBody } from "reactstrap"
import axios from "axios"
import moment from "moment"
import { parse, format, isValid } from "date-fns";
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Dialog } from "primereact/dialog"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { ConfirmDialog } from "primereact/confirmdialog"
import { FileUpload } from "primereact/fileupload"
import { InputNumber } from "primereact/inputnumber"
import { InputTextarea } from "primereact/inputtextarea"
import { TreeSelect } from "primereact/treeselect"
import { Controller, useForm } from "react-hook-form"
import { triggerAlert } from "utils/CommonFunctions"
import Select from "react-select"
import {
  MaxLengthValidation,
  MinLengthValidation,
  onlyNumbers,
} from "utils/Constants"
import { Toast } from "primereact/toast"
import { Checkbox } from "primereact/checkbox"

const UploadResumeForm = () => {
  // Remove a single skill from a field (primary_skills, secondary_skills, other_skills)
  const handleRemoveSkill = (field, skillToRemove) => {
    const currentSkills = getValues(field) || [];
    const updatedSkills = currentSkills.filter(skill => skill.name !== skillToRemove.name);
    setValue(field, updatedSkills);
  };
  // Helper to map skill strings to objects for correct display in fields
  const mapSkillsToObjects = (skillsArr) => {
    if (!Array.isArray(skillsArr)) return [];
    return skillsArr.map(skill => {
      // Try to find the skill in primarySkillsget for id
      const found = primarySkillsget?.find(opt => opt.name?.toLowerCase() === skill?.toLowerCase());
      // Always return both name and id (use skill string as id if not found)
      return found ? { name: found.name, id: found.id } : { name: skill, id: skill };
    });
  };
  const location = useLocation()
  const navigate = useNavigate()
  const resumeData = location.state?.resumeData?.data[0]
  const resumeFile = location.state?.resumeFile

  // console.log('location.state',location.state)
  const toast = useRef(null)

  const userInfo = JSON.parse(sessionStorage.getItem("userinfoCookie") || "{}")
  const userId = userInfo?.user_details?.unique_user_id
  const now = new Date()

  const {
    register,
    handleSubmit,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    getValues,
    watch,
    control,
  } = useForm({
    defaultValues: {
      created_at: now,
      updated_at: now,
      last_activity_date: now,
      created_by: userId || "",
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      mobile_phone: "",
      current_company: "",
      job_title: "",
      total_experience: null,
    },
    mode: "onChange",
  }) // keep as Date for Calendar

  const [uniqueUserId, setUniqueUserId] = useState("")
  const {
    register: registerDoc,
    handleSubmit: handleSubmitDoc,
    reset: resetDocForm,
    control: controlDoc,
    formState: { errors: errorsDoc }, // ✅ FIX HERE
  } = useForm({
    defaultValues: {
      selected_document: null, // 👈 this must exist
      subject: "",
      file: null,
    },
    mode: "onChange",
  })
  const {
    register: registerWork,
    handleSubmit: handleSubmitWork,
    reset: resetWork,
    control: controlWork,
    formState: { errors: errorsWork },
  } = useForm({
    defaultValues: {
      company_name: "",
      website: "",
      job_title: "",
      start_date: null,
      end_date: null,
    },
    mode: "onChange",
  })

  const {
    control: eduControl,
    handleSubmit: handleSubmitEdu,
    reset: resetEduForm,
    watch: watchEdu,
    formState: { errors: eduErrors },
  } = useForm({
    defaultValues: {
      school_name: "",
      degree: "",
      field_of_study: "",
      start_year: null,
      start_month: null,
      end_year: null,
      end_month: null,
      grade: "",
    },
    mode: "onChange",
  })

  const [firstname, setFirstname] = useState("")
  const [lastname, setLastname] = useState("")
  const [company, setCompany] = useState("")
  const [jobtitle, setJobtitle] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [address, setAddress] = useState("")
  const [originalAddress, setOriginalAddress] = useState("")
  const [selectedStatus, setSelectedStatus] = useState(null)
  const [primarySkills, setPrimarySkills] = useState(
    resumeData?.primary_skills || []
  )
  const [addressLabels, setAddressLabels] = useState([]);
  const [secondarySkills, setSecondarySkills] = useState(
    resumeData?.secondary_skills || []
  )
  const [dateAvailability, setDateAvailability] = useState(null)
  const [dob, setDob] = useState(null)
  const [employeeRec, setEmployeeRec] = useState(null)
  const [dateFromTo, setDateFromTo] = useState(null)
  const [merge, setMerge] = useState(false)
  const [showCancelDialog, setShowCancelDialog] = useState(false)
  //sais code
  const [isDuplicateEmail, setIsDuplicateEmail] = useState(false)
  const [duplicateCandidateId, setDuplicateCandidateId] = useState(null)
  const [emailError, setEmailError] = useState("")
  const emailInputRef = useRef(null)
  

  const [visible, setVisible] = useState(false)
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [selectedLabel1, setSelectedLabel1] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [addCountries, setAddCountries] = useState([])
  const [addStates, setAddStates] = useState([])
  const [addCities, setAddCities] = useState([])
  const [selectedGroupKey, setSelectedGroupKey] = useState(null)
  const [groupitem, setgroupitem] = useState([])
  const [fileData, setFileData] = useState(null)
  const [error, setError] = useState("")
  const [editIndex, setEditIndex] = useState(null)
  const [showDialog, setShowDialog] = useState(false)
  const labels = [
    { name: "Work From Office ", code: "Work From Office" },
    { name: "Work From Home", code: "Work From Home" },
    { name: "Work From Remote", code: "Work From Remote" },
  ]
  const [workExperiences, setWorkExperiences] = useState([])
  const [formValues, setFormValues] = useState({
    company_name: "",
    website: "",
    job_title: "",
    start_date: "",
    end_date: "",
    description: "",
  })
  const [documentTypes, setDocumentTypes] = useState([])
  const [employeeTypes, setEmployeeTypes] = useState([])
  const normalizeField = field => {
    if (Array.isArray(field)) {
      return field[0] || ""
    }
    return field || ""
  }

function formatDisplayDate(dateStr) {
  if (!dateStr) return "";
  if (typeof dateStr !== "string") return "";

  // Handle "Present" (case-insensitive)
  if (dateStr.trim().toLowerCase() === "present") return "Present";

  // Try "YYYY-MM-DD"
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const d = parse(dateStr, "yyyy-MM-dd", new Date());
    if (isValid(d)) return format(d, "MMMM yyyy"); // "June 2019"
  }

  // Try "Month YYYY" (e.g., "October 2022")
  if (/^[A-Za-z]+\s\d{4}$/.test(dateStr)) {
    // Try parsing with "MMMM yyyy"
    const d = parse(dateStr, "MMMM yyyy", new Date());
    if (isValid(d)) return format(d, "MMMM yyyy");
    // Try parsing with "MMM yyyy"
    const d2 = parse(dateStr, "MMM yyyy", new Date());
    if (isValid(d2)) return format(d2, "MMMM yyyy");
    // If not valid, just return as is
    return dateStr;
  }

  // Try "MMM YYYY" (e.g., "Jun 2019")
  if (/^[A-Za-z]{3}\s\d{4}$/.test(dateStr)) {
    const d = parse(dateStr, "MMM yyyy", new Date());
    if (isValid(d)) return format(d, "MMMM yyyy");
    return dateStr;
  }

  // Try parsing as Date
  const d = new Date(dateStr);
  if (isValid(d)) return format(d, "MMMM yyyy");

  // Fallback: return as is
  return dateStr;
}

  const getDocumentTypes = async () => {
    try {
      const response = await axios.get("api/v1/get-all-document-type/")
      if (response.data?.results) {
        const transformedData = response.data.results.map(doc => ({
          label: doc.value,
          value: doc.value,
        }))
        setDocumentTypes([
          {
            label: "Proof of Identity",
            items: transformedData,
          },
        ])
      }
    } catch (error) {
      console.error("Error fetching document types:", error)
      triggerAlert("error", "Error", "Failed to fetch document types.")
    }
  }

  const fetchAddressLabels = async () => {
  try {
    const response = await axios.get(
      "/api/v1/get-all-address-label/"
      // Add Authorization header if needed
    );
    if (response?.data?.results) {
      setAddressLabels(
        response.data.results.map(label => ({
          label: label.address_label,
          value: label.id,
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching address labels:", error);
  }
};

  const fetchEmployeeTypes = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-employee-type/");
      if (response?.data?.results) {
        setEmployeeTypes(
          response.data.results.map(type => ({
            label: type.employee_type,
            value: type.id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching employee types:", error);
      triggerAlert("error", "Error", "Failed to fetch employee types.");
    }
  };

  // const selectedCategoryKey = watch("category") // Listen to category changes
  const [selectedCategoryKey, setSelectedCategoryKey] = useState(null)

  const [educationDetails, setEducationDetails] = useState([])
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [deleteWorkVisible, setDeleteWorkVisible] = useState(false)
  const [workToDelete, setWorkToDelete] = useState(null)
  const [deleteEduVisible, setDeleteEduVisible] = useState(false)
  const [eduToDelete, setEduToDelete] = useState(null)
  const [editEduIndex, setEditEduIndex] = useState(null)
  //States
  const [primarySkillsget, setprimarySkillsget] = useState([])
  const [categoriesitem, setcategoriesitem] = useState([])

  //document states
  const [documents, setDocuments] = useState([])
  const [displayDialog, setDisplayDialog] = useState(false) // Modal visibility state

  const [sourceOptions, setSourceOptions] = useState([])

  const groupedItemTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className="pi pi-file mr-2"></i>
        <div>{option.label}</div>
      </div>
    )
  }

  const formatToDateTime = (date = new Date()) => {
    const pad = n => String(n).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`
  }

  const years = Array.from({ length: 50 }, (_, i) => {
    const year = new Date().getFullYear() - i
    return { label: year.toString(), value: year.toString() }
  })
  const months = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ]

  // helper functions
  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result.split(",")[1])
      reader.onerror = error => reject(error)
    })
  }

  // sais code
  useEffect(() => {
    const checkDuplicateEmail = async email => {
      if (!email) return
      try {
        const response = await axios.post(
          "/api/v1/candidates/check-email/",
          { email }
        )
        if (response.data.duplicate) {
          setIsDuplicateEmail(true)
          setDuplicateCandidateId(response.data.candidate_id)
          setEmailError("Candidate with this email already exists.")
        } else {
          setIsDuplicateEmail(false)
          setDuplicateCandidateId(null)
          setEmailError("")
        }
      } catch (err) {
        setIsDuplicateEmail(false)
        setDuplicateCandidateId(null)
        setEmailError("Failed to check duplicate email.")
      }
    }

    if (!resumeData && !resumeFile) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong. No data available.",
        life: 3000,
      })
      navigate(-1)
    } else {
      // ...existing code...
      setEmail(email)
      setValue("email", email)

      // Check for duplicate email here
      checkDuplicateEmail(email)

      // ...rest of your code...
    }
  }, [resumeData, resumeFile, setValue, primarySkillsget])

  // const handleFileChange = async event => {
  //   const file = event.target.files[0]
  //   if (!file) return
  //   // Validate file type
  //   const allowedTypes = ["application/pdf"]
  //   if (!allowedTypes.includes(file.type)) {
  //     setError(" PDF files are allowed.")
  //     return
  //   }
  //   // Validate file size (max 10MB)
  //   const maxSize = 10 * 1024 * 1024 // 10MB
  //   if (file.size > maxSize) {
  //     setError("File size should not exceed 10MB.")
  //     return
  //   }
  //   setError("") // Clear errors
  //   try {
  //     const base64 = await getBase64(file)
  //     setFileData({
  //       name: file.name,
  //       type: file.type,
  //       base64: base64,
  //     }) // Store only base64 content
  //   } catch (error) {
  //     setError("Error while converting file to base64.")
  //   }
  // }

  const handleFileChange = async event => {
    const file = event.target.files[0]
    if (!file) return
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ]
    if (!allowedTypes.includes(file.type)) {
      setError(
        "Only PDF, Word (doc, docx), and image (jpg, jpeg, png) files are allowed."
      )
      return
    }
    const maxSize = 5 * 1024 * 1024
    if (file.size > maxSize) {
      setError("File size should not exceed 5MB.")
      return
    }
    setError("")
    try {
      const base64 = await getBase64(file)
      console.log("handleFileChange base64", base64)
      setFileData({
        name: file.name,
        type: file.type,
        base64,
      })
    } catch (error) {
      setError("Error converting file to base64.")
    }
  }
  console.log("fileData", fileData)
  const openAddDocumentDialog = () => {
    setDisplayDialog(true)
  }

  const closeAddDocumentDialog = () => {
    setDisplayDialog(false)
  }

  const setstatus = [
    { name: "Active", code: "act" },
    { name: "Inactive", code: "inc" },
  ]

  const cities = [
    { name: "Freelancer", code: "emp1" },
    { name: "WFH", code: "emp2" },
    { name: "WFO", code: "emp3" },
  ]

  useEffect(() => {
    if (!resumeData && !resumeFile) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong. No data available.",
        life: 3000,
      })
      navigate(-1)
    } else {
      const firstName = normalizeField(resumeData?.contact_info?.first_name)
      const middleName = normalizeField(resumeData?.contact_info?.middle_name)
      const lastName = normalizeField(resumeData?.contact_info?.last_name)
      const email = normalizeField(resumeData?.contact_info?.email)
      const mobilePhone = normalizeField(resumeData?.contact_info?.phone)
      const currentCompany = normalizeField(
        resumeData?.employment_history?.employer_1?.employer_name
      )
      const jobTitle = normalizeField(
        resumeData?.employment_history?.employer_1?.position
      )
      const workPhone = resumeData?.work_phone || ""

      setValue("first_name", firstName)
      setValue("middle_name", middleName)
      setValue("last_name", lastName)
      setValue("email", email)
      setValue("mobile_phone", mobilePhone)
      setValue("current_company", currentCompany)
      setValue("job_title", jobTitle)
      setValue("work_phone", workPhone)

      setFirstname(firstName)
      setLastname(lastName)
      setCompany(currentCompany)
      setJobtitle(jobTitle)
      setEmail(email)
      setPhone(mobilePhone)

      const rawExperience = resumeData?.contact_info?.total_experience || [0, 0]
      const [years, months] = Array.isArray(rawExperience)
        ? rawExperience
        : [0, 0]
      const experienceDecimal = parseFloat(`${years}.${months}`)
      setValue("total_experience", experienceDecimal)

      setAddress(
        `${normalizeField(resumeData?.contact_info?.country)}, ${normalizeField(
          resumeData?.contact_info?.city
        )}, ${normalizeField(
          resumeData?.contact_info?.postal_code
        )}, ${normalizeField(resumeData?.contact_info?.region)}`
      )


      const normalizedResumeSkills =


        setValue("primary_skills", mapSkillsToObjects(resumeData?.primary_skills)); // Skills field
        setValue("secondary_skills", mapSkillsToObjects(resumeData?.secondary_skills)); // Secondary Skills field
        setValue("other_skills", mapSkillsToObjects(resumeData?.skills)); // Other Skills field

      setFileData({
        name: resumeFile?.name,
        type: resumeFile?.type,
        base64: resumeFile?.base64,
      })
      console.log("resumeFile", resumeFile)
    }
  }, [resumeData, resumeFile, setValue, primarySkillsget])

  const handleSaveClick = () => {
    setMerge(true)
  }

  const handleCancelClick = () => {
    setShowCancelDialog(true)
  }

  const handleConfirmCancel = () => {
    navigate("/allactive-candidates")
  }

  const handleDeclineCancel = () => {
    setShowCancelDialog(false)
  }

  const footerContent = (
    <div className="d-flex justify-content-center">
      <button
        type="button"
        onClick={() => {
          navigate("/allactive-candidates")
        }}
        className="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2"
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => {
          navigate("/allactive-candidates")
        }}
        className="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2"
      >
        No
      </button>
    </div>
  )

  const customBase64Uploader = async event => {
    const file = event.files[0]
    const reader = new FileReader()
    let blob = await fetch(file.objectURL).then(r => r.blob())

    reader.readAsDataURL(blob)

    reader.onloadend = function () {
      const base64data = reader.result
      // You can handle the base64data as needed, e.g., send it to an API
    }
  }

  //get calls
  const getresumesources = async () => {
    try {
      const response = await axios.get(`/api/v1/resume-source/`, {})
      const transformedData = response.data.results.map(workv => ({
        label: workv.resume_source,
        value: workv.source_id,
      }))
      setSourceOptions(transformedData)
    } catch (error) {}
  }
  const getskills = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-skills/`, {})
      const transformedData = response.data.results.map(workv => ({
        name: workv.skill_name,
        id: workv.skill_id,
      }))
      setprimarySkillsget(transformedData)
    } catch (error) {}
  }

  // const getcategoriesitem = async () => {
  //   try {
  //     const response = await axios.get(`/api/v1/get-all-categories/`, {})
  //     if (response.data && response.data.results) {
  //       const transformedData = response.data.results.map(Categories => ({
  //         name: Categories.name,
  //         id: Categories.category_id,
  //       }))
  //       setcategoriesitem(transformedData)
  //     }
  //   } catch (error) {}
  // }
  // const getgroupsitemsub = async category_ids => {
  //   try {
  //     const response = await axios.get(
  //       `/api/v1/get-all-groups/?category_id=${category_ids}`,
  //       {}
  //     )
  //     if (response.data && response.data.results) {
  //       const transformedDatagroup = response.data.results.map(Groups => ({
  //         name: Groups.name,
  //         id: Groups.group_id,
  //       }))
  //       setgroupitem(transformedDatagroup)
  //     }
  //   } catch (error) {}
  // }

  const transformCategoriesToTree = categories => {
    const buildTree = category => ({
      key: category.category_id,
      label: category.name,
      data: category,
      children: category.subcategories
        ? category.subcategories.map(buildTree)
        : [],
    })
    return categories.map(buildTree)
  }

  const transformGroupsToTree = groups => {
    const buildTree = group => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group.subgroups ? group.subgroups.map(buildTree) : [],
    })
    return groups.map(buildTree)
  }

  const getcategoriesitem = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response.data?.results) {
        const treeData = transformCategoriesToTree(response.data.results)
        setcategoriesitem(treeData)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }

  const getgroupsitemsub = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response.data?.results) {
        const groupTree = transformGroupsToTree(response.data.results)
        setgroupitem(groupTree)
      }
    } catch (error) {
      console.error("Error fetching groups:", error)
    }
  }

  const getaddCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`, {})
      const transformedData = response.data.results.map(Countries => ({
        name: Countries.name,
        id: Countries.country_id,
      }))
      setAddCountries(transformedData)
    } catch (error) {}
  }
  const getaddStates = async countryId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`,
        {}
      )
      const transformedData = response.data.results.map(city => ({
        name: city.name,
        id: city.state_id,
      }))
      setAddStates(transformedData)
    } catch (error) {}
  }
  const getaddCities = async stateId => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`,
        {}
      )
      const transformedData = response.data.results.map(city => ({
        name: city.name,
        id: city.city_id,
      }))
      setAddCities(transformedData)
    } catch (error) {}
  }

  useEffect(() => {
    if (addCountries && selectedCountry?.id) {
      getaddStates(selectedCountry?.id)
    }
  }, [selectedCountry, addCountries])
  useEffect(() => {
    if (selectedState) {
      getaddCities(selectedState.id)
    }
  }, [selectedState])

  useEffect(() => {
    getcategoriesitem()
    getskills()
    getaddCountries()
    getresumesources()
    fetchAddressLabels();
    getDocumentTypes()
    fetchEmployeeTypes()
    const userInfo = JSON.parse(sessionStorage.getItem("user-info"))
    if (userInfo && userInfo.user_details) {
      setUniqueUserId(userInfo.user_details.unique_user_id)
    }
  }, [])

  useEffect(() => {
    if (selectedCategoryKey) {
      getgroupsitemsub(selectedCategoryKey)
    }
  }, [selectedCategoryKey])



  const onSubmit = async data => {
    if (isDuplicateEmail) {
      setEmailError("Candidate with this email already exists.")
      setTimeout(() => {
        const emailInput = document.querySelector('input[name="email"]')
        if (emailInput) {
          emailInput.scrollIntoView({ behavior: "smooth", block: "center" })
          emailInput.focus()
        }
      }, 100)
      return
    }
    try {
      if (!fileData) {
        setError("Please upload resume")
        return
      }
      setIsLoading(true)

      const normalizedData = {
        ...data,
        first_name: normalizeField(data.first_name),
        middle_name: normalizeField(data.middle_name),
        last_name: normalizeField(data.last_name),
        email: normalizeField(data.email),
        mobile_phone: normalizeField(data.mobile_phone),
        current_company: normalizeField(data.current_company),
        job_title: normalizeField(data.job_title),
        work_phone: data.work_phone || null,
      }

      // if (!normalizedData.work_phone) {
      //   setError("Work phone is required.");
      //   setIsLoading(false);
      //   return;
      // }
      if (fileData) {
        // normalizedData.resume = fileData?.base64;
        normalizedData.resume = {
          file_name: fileData?.name,
          file_data: fileData?.base64,
        }
      }
      if (street1) {
        normalizedData.street_address = street1
      }
      if (street2) {
        normalizedData.street_address_line_2 = street2
      }
      if (selectedState?.id) {
        normalizedData.state = selectedState?.id
      }
      if (selectedCity?.id) {
        normalizedData.city = selectedCity?.id
      }
      if (selectedCountry?.id) {
        normalizedData.country = selectedCountry?.id
      }
      if (postalCode) {
        normalizedData.pincode = postalCode
      }
      if (selectedLabel1) {
  normalizedData.label = selectedLabel1; // This is the id from dropdown
}

      if (normalizedData.primary_skills) {
        normalizedData.primary_skills = normalizedData.primary_skills.map(
          skill => skill.name
        )
      }
      if (normalizedData.secondary_skills) {
        normalizedData.secondary_skills = normalizedData.secondary_skills.map(
          skill => skill.name
        )
      }
      if (normalizedData.other_skills) {
        normalizedData.other_skills = normalizedData.other_skills.map(
          skill => skill.name
        )
      }

      normalizedData.availability_date = normalizedData.availability_date
        ? moment(normalizedData.availability_date).format("YYYY-MM-DD")
        : null
      normalizedData.dob = normalizedData.dob
        ? moment(normalizedData.dob).format("YYYY-MM-DD")
        : null

      delete normalizedData.created_at
      delete normalizedData.updated_at
      delete normalizedData.last_activity_date
      delete normalizedData.created_by

      const payload = {
        ...normalizedData,
        documents: documents?.map(doc => ({
          type: doc.selected_document,
          subject: doc.subject,
          file: doc.file?.base64,
          file_name: doc.file?.name,
        })),
        work_details: workExperiences?.map(exp => ({
          company_name: exp.company_name,
          website: exp.website,
          job_title: exp.job_title,
          start_date: exp.start_date,
          end_date: exp.end_date,
        })),
        educations: educationDetails,
      }

      const response = await axios.post(`/api/v1/candidates/`, payload)
      if (response.status === 201) {
        triggerAlert("success", "Success", "Candidate Updated Successfully.")
        navigate("/allactive-candidates")
      } else {
        triggerAlert(
          "error",
          "Error",
          "Failed to update candidate. Please try again."
        )
      }
    } catch (error) {
      console.error("Error:", error)
      triggerAlert(
        "error",
        "Error",
        "Failed to update candidate. Please try again."
      )
    } finally {
      setIsLoading(false)
    }
  }

  const formatEducationData = educationHistory => {
    return Object.values(educationHistory)
      .filter(edu => Object.keys(edu).length > 0)
      .map(edu => {
        const dateParts = (edu.last_education_date || "").split(" ")
        let month = "-"
        let year = "-"

        dateParts.forEach(part => {
          if (/[a-zA-Z]/.test(part)) {
            month = part
          } else if (/\d/.test(part)) {
            year = part
          }
        })

        return {
          degree: edu.degree_name || "-",
          school_name: edu.school_name || "-",
          field_of_study: edu.major || "-",
          grade: "-",
          start_year: "-",
          start_month: "-",
          end_year: year,
          end_month: month,
        }
      })
  }

  const handleRemoveFile = () => {
    setFileData(null)
    setError("")
  }
  useEffect(() => {
    if (resumeData?.education_history) {
      const parsedEducation = formatEducationData(resumeData.education_history)
      setEducationDetails(parsedEducation)
    }
  }, [resumeData])

useEffect(() => {
  if (resumeData?.employment_history) {
    const transformed = Object.values(resumeData.employment_history).map(item => ({
      company_name: item.employer_name,
      job_title: item.position,
      start_date: item.start_date, // keep original string
      end_date: item.end_date || "Present", // handle missing end_date
    }));
    setWorkExperiences(transformed);
  }
}, [resumeData]);

  // Helper to parse "Jan 2022" -> "2022-01-01"
  const parseDate = dateStr => {
    try {
      const parsed = parse(dateStr, "MMM yyyy", new Date())
      return format(parsed, "yyyy-MM-dd")
    } catch (e) {
      console.warn("Date parse failed for:", dateStr)
      return "" // fallback if invalid
    }
  }

  // console.log("errors", errors);

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={6}>
                <h6 className="page-title">Create a Candidate</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Add a new candidate by entering their details, skills, and
                    contact information. Streamline recruitment by creating
                    comprehensive profiles.
                  </li>
                </ol>
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={handleSubmit(onSubmit)}
                    disabled={isLoading}
                    className="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary me-2"
                  >
                    <i class="pi pi-save me-1"></i>{" "}
                    {isLoading ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      navigate("/allactive-candidates")
                    }}
                    className="btn btn-primary waves-effect waves-light outlinebtn btn btn-primary"
                  >
                    <i class="pi pi-times me-1"></i>Cancel
                  </button>
                </div>
              </Col>
            </Row>
          </div>

          <Row>
            <Col xl={4}>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-4">Basic Information</h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="integer" className="block mb-2">
                                  First name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  placeholder=""
                                  {...register("first_name", {
                                    required: "First name is required*",
                                    pattern: {
                                      value: /^[A-Za-z][A-Za-z-\s&]*$/,
                                      message:
                                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    },
                                  })}
                                  onKeyUp={() => trigger("first_name")}
                                />
                                {errors.first_name && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.first_name.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="integer" className="block mb-2">
                                  Middle name
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  placeholder=""
                                  {...register("middle_name", {
                                    pattern: {
                                      value: /^[A-Za-z][A-Za-z-\s&]*$/,
                                      message:
                                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    },
                                  })}
                                  onKeyUp={() => trigger("middle_name")}
                                />
                                {errors.middle_name && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.middle_name.message}
                                  </small>
                                )}
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="integer" className="block mb-2">
                                  Last name
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  placeholder=""
                                  {...register("last_name", {
                                    pattern: {
                                      value: /^[A-Za-z][A-Za-z-\s&]*$/,
                                      message:
                                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    },
                                  })}
                                  onKeyUp={() => trigger("last_name")}
                                />
                                {errors.last_name && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.last_name.message}
                                  </small>
                                )}
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="integer" className="block mb-2">
                                  Company
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  placeholder=""
                                  {...register("current_company", {
                                    pattern: {
                                      value: /^[A-Za-z][A-Za-z-\s&]*$/,
                                      message:
                                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    },
                                  })}
                                  onKeyUp={() => trigger("current_company")}
                                />
                                {errors.current_company && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.current_company.message}
                                  </small>
                                )}
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="integer" className="block mb-2">
                                  JobTitle
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  {...register("job_title", {
                                    pattern: {
                                      value: /^[A-Za-z][A-Za-z-\s&]*$/,
                                      message:
                                        "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    },
                                  })}
                                  onKeyUp={() => trigger("job_title")}
                                />
                                {errors.job_title && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.job_title.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block mb-2">
                                  Status <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                                <div className="card flex justify-content-center mb-0">
                                  <select
                                    className="form-select profileDetailsInput"
                                    id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                                    aria-label="Default select example"
                                    {...register("status", {
                                      required: "Status is required",
                                    })} // Added required validation
                                    defaultValue="Active" // Set default value to "Active"
                                  >
                                    <option value="" hidden>
                                      Select
                                    </option>
                                    <option value='Active'>Active</option>
                <option value='InActive'>InActive</option>
                <option value='DND(Do Not Disturb)'>DND(Do Not Disturb)</option>
                <option value='Blacklisted'>Blacklisted</option>
                                  </select>
                                </div>
                                {errors.status && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.status.message}
                                  </small>
                                )}
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label
                                  htmlFor="total_experience"
                                  className="block mb-2"
                                >
                                  Total Experience
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="total_experience"
                                  control={control} // from useForm()
                                  // rules={{ required: "Total experience is required" }}
                                  render={({
                                    field: { onChange, value },
                                    fieldState: { error },
                                  }) => (
                                    <>
                                      <InputNumber
                                        inputId="total_experience"
                                        value={value}
                                        onValueChange={e => onChange(e.value)}
                                        minFractionDigits={1}
                                        maxFractionDigits={1}
                                        mode="decimal"
                                        placeholder=""
                                        className={`w-full drop-clr ${
                                          error ? "p-invalid" : ""
                                        }`}
                                      />
                                      {error && (
                                        <small className="text-danger">
                                          {error.message}
                                        </small>
                                      )}
                                    </>
                                  )}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Contact Information</h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Email <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                              {/* sais code */}
                                <InputText
                                  name="email"
                                  className="w-full"
                                  inputRef={emailInputRef}
                                  {...register("email", {
                                    required: "Email is Required*",
                                    pattern: {
                                      value:
                                        /^[A-Z0-9._%+-]+@[A-Z.-]{2,}\.+[A-Z]{2,}$/i,
                                      message: "Please enter valid Email",
                                    },
                                    onChange: async event => {
                                      const value =
                                        event.target.value.toLowerCase()
                                      setValue("email", value)
                                      setEmail(value)

                                      // Check for duplicate email on every change
                                      if (value) {
                                        try {
                                          const response = await axios.post(
                                            "/api/v1/candidates/check-email/",
                                            { email: value }
                                          )
                                          if (response.data.duplicate) {
                                            setIsDuplicateEmail(true)
                                            setDuplicateCandidateId(
                                              response.data.candidate_id
                                            )
                                            setEmailError(
                                              "Candidate with this email already exists."
                                            )
                                          } else {
                                            setIsDuplicateEmail(false)
                                            setDuplicateCandidateId(null)
                                            setEmailError("")
                                          }
                                        } catch (err) {
                                          setIsDuplicateEmail(false)
                                          setDuplicateCandidateId(null)
                                          setEmailError(
                                            "Failed to check duplicate email."
                                          )
                                        }
                                      } else {
                                        setIsDuplicateEmail(false)
                                        setDuplicateCandidateId(null)
                                        setEmailError("")
                                      }
                                    },
                                  })}
                                />
                                {(isDuplicateEmail || emailError) && (
                                  <div className="mt-2">
                                    <small className="form-text text-danger">
                                      {emailError ||
                                        "Candidate with this email already exists."}
                                    </small>
                                    {isDuplicateEmail &&
                                      duplicateCandidateId && (
                                        <Button
                                          className="btn btn-warning ms-2"
                                          onClick={() =>
                                            navigate(
                                              `/candidate-editform?candidate_id=${duplicateCandidateId}`
                                            )
                                          }
                                        >
                                          Edit Candidate
                                        </Button>
                                      )}
                                  </div>
                                )}
                                {errors.email && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.email.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Secondary Email
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  name="email_1"
                                  className="w-full"
                                  {...register("email_1", {
                                    // required: "Please enter Email",
                                    pattern: {
                                      value:
                                        /^[A-Z0-9._%+-]+@[A-Z.-]{2,}\.+[A-Z]{2,}$/i,
                                      message: "Please enter valid Email", // JS only: <p>error message</p> TS only support string
                                    },
                                    onChange: event =>
                                      (event.target.value =
                                        event.target.value.toLowerCase()),
                                  })}
                                />
                                {errors.email_1 && (
                                  <small
                                    id="personalEmailHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.email_1.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block mb-2">
                                  Work Phone{" "}
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
  className="w-full"
  {...register("work_phone", {
    pattern: {
      value: /^[0-9]{10,15}$/,
      message: "Only numbers are allowed and must be 10 to 15 digits",
    },
    validate: value =>
      !/^0+$/.test(value) || "Phone number cannot be all zeros",
    minLength: {
      value: 10,
      message: "Please enter at least 10 digits",
    },
    maxLength: {
      value: 15,
      message: "Please enter no more than 15 digits",
    },
  })}
/>
                                {errors.work_phone && (
                                  <small
                                    id="workPhoneHelp"
                                    className="form-text text-danger"
                                  >
                                    {errors.work_phone.message}
                                  </small>
                                )}
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Mobile Phone{" "}
                                  <span className="text-danger">*</span>
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
  className="w-full"
  {...register("mobile_phone", {
    required: "This field is required *",
    pattern: {
      value: /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3,5}\)?[-.\s]?)?\d{3,5}[-.\s]?\d{4,5}$/,
      message: "Please enter a valid phone number (e.g. +91 98765 43210 or (617) 123-4567)",
    },
    validate: value =>
      !/^0+$/.test(value.replace(/\D/g, "")) || "Phone number cannot be all zeros",
    minLength: {
      value: 10,
      message: "Please enter at least 10 digits",
    },
    maxLength: {
      value: 15,
      message: "Please enter no more than 15 digits",
    },
  })}
  onKeyUp={e => {
    trigger("mobile_phone")
  }}
/>
{errors.mobile_phone && (
  <small id="phoneNoHelp" className="form-text text-danger">
    {errors.mobile_phone.message}
  </small>
)}

                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="address">Address</label>
                              </Col>
                              <Col xl={9}>
                                <div
                                  className="companie-add"
                                  style={{ position: "relative" }}
                                >
                                  <InputTextarea
                                    id="address"
                                    value={address}
                                    readOnly
                                    placeholder=""
                                    rows={3}
                                    cols={20}
                                    className="w-full"
                                  />

                                  {/* Edit Icon */}
                                  <i
                                    className="pi pi-pencil"
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      bottom: "10px",
                                      color: "#6c757d",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => { setOriginalAddress(address); setVisible(true); }}
                                  ></i>
                              

                                  <Dialog
                                    header="Edit Address"
                                    className="address-popup"
                                    visible={visible}
                                    onHide={() => {
                                      if (!visible) return
                                      setVisible(false)
                                    }}
                                    style={{ width: "30vw" }}
                                    breakpoints={{
                                      "960px": "75vw",
                                      "641px": "100vw",
                                    }}
                                  >
                                    <div className="card sidebardetails">
                                      <form>
                                        <Row className="mb-3">
                                          <Col lg={6}>
                                            <div className="p-field">
                                              <label htmlFor="street1">
                                                Street 1
                                              </label>
                                              <InputText
                                                id="street1"
                                                value={street1}
                                                onChange={e => {
                                                  setStreet1(e.target.value)
                                                }}
                                                placeholder="Enter Street 1"
                                                className="w-full activejobdrop"
                                              />
                                            </div>
                                          </Col>
                                          <Col lg={6}>
                                            <label htmlFor="street2">
                                              Street 2
                                            </label>
                                            <InputText
                                              id="street2"
                                              value={street2}
                                              onChange={e => {
                                                setStreet2(e.target.value)
                                              }}
                                              placeholder="Enter Street 2 (Optional)"
                                              className="w-full activejobdrop"
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col lg={6}>
                                            <label htmlFor="country">
                                              Country
                                            </label>
                                            <Dropdown
                                              id="country"
                                              value={selectedCountry?.id} // Dropdown expects just the ID
                                              onChange={e => {
                                                const selected =
                                                  addCountries.find(
                                                    item => item.id === e.value
                                                  )
                                                setSelectedCountry(selected) // Store full object { id, name }
                                              }}
                                              options={addCountries}
                                              optionLabel="name"
                                              optionValue="id"
                                              filter
                                              filterPlaceholder="Search Country"
                                              className="w-full activejobdrop"
                                              placeholder="Enter country details..."
                                            />
                                          </Col>
                                          <Col lg={6}>
                                            <label htmlFor="state">State</label>
                                            <Dropdown
                                              id="state"
                                              value={selectedState?.id}
                                              onChange={e => {
                                                const selected = addStates.find(
                                                  item => item.id === e.value
                                                )
                                                setSelectedState(selected) // Store full object { id, name }
                                              }}
                                              options={addStates}
                                              optionLabel="name"
                                              optionValue="id"
                                              filter
                                              filterPlaceholder="Search State"
                                              className="w-full activejobdrop"
                                              placeholder="Enter state details..."
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col lg={6}>
                                            <label htmlFor="city">City</label>
                                            <Dropdown
                                              id="city"
                                              value={selectedCity?.id}
                                              onChange={e => {
                                                const selected = addCities.find(
                                                  item => item.id === e.value
                                                )
                                                setSelectedCity(selected) // Store full object { id, name }
                                              }}
                                              options={addCities}
                                              optionLabel="name"
                                              optionValue="id"
                                              filter
                                              filterPlaceholder="Search City"
                                              className="w-full activejobdrop"
                                              placeholder="Enter city details..."
                                            />
                                          </Col>
                                          <Col lg={6}>
                                            <label htmlFor="postalCode">
                                              Postal Code
                                            </label>
                                            <InputText
                                              id="postalCode"
                                              value={postalCode}
                                              onChange={e => {
                                                setPostalCode(e.target.value)
                                              }}
                                              placeholder="Enter Postal Code"
                                              className="w-full activejobdrop"
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-3">
                                          <Col lg={12}>
                                            <label htmlFor="postalCode">
                                              Label
                                            </label>
                                            <Dropdown
                                              value={selectedLabel1}
                                              onChange={e => {
                                                setSelectedLabel1(e.value)
                                              }}
                                              options={addressLabels}
                                              optionLabel="label"
                                              optionValue="value"
                                              placeholder="Select a Label"
                                              className="w-full activejobdrop"
                                            />
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            <Button
                                              type="button"
                                              color="primary"
                                              className="btn btn-primary  waves-light me-2 sidebarbtn"
                                              onClick={() => {
                                                const labelText = addressLabels.find(l => l.value === selectedLabel1)?.label;
                                                const parts = [
                                                  street1,
                                                  street2,
                                                  selectedCity?.name,
                                                  selectedState?.name,
                                                  selectedCountry?.name,
                                                  postalCode,
                                                  labelText
                                                ].filter(part => part && part.trim() !== "");
                                                const newAddress = parts.join(", ");
                                                setAddress(newAddress);
                                                setVisible(false);
                                              }}
                                            >
                                              <i className="pi pi-check me-1"></i>{" "}
                                              Ok
                                            </Button>
                                            <Button
                                              type="button"
                                              color="secondary"
                                              className="btn btn-secondary waves-light me-2"
                                              onClick={() => { setAddress(originalAddress); setVisible(false); }}
                                            >
                                              Cancel
                                            </Button>
                                          </Col>
                                        </Row>
                                      </form>
                                    </div>
                                  </Dialog>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Skills</h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="primarySkills" className="mb-0">
                                  Skills
                                </label>
                              </Col>
                              <Col xl={9}>
                                {/* <Select
                id="primarySkills"
                name="primarySkills"
                isMulti
                options={primarySkillsget} // array of objects with { id, name }
                getOptionLabel={(e) => e.name} // like optionLabel
                getOptionValue={(e) => e.id}   // like optionValue
                value={primarySkillsview} // selected options as array
                onChange={(selectedOptions) => setprimarySkillsview(selectedOptions)}
                placeholder="Javascript, React"
                className="w-full"
              /> */}

                                <Controller
                                  name="primary_skills"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      isMulti
                                      options={primarySkillsget}
                                      getOptionLabel={e => e.name}
                                      getOptionValue={e => e.id}
                                      className="w-full"
                                      placeholder="Javascript, React"
                                      value={field.value || []}
                                      onChange={selected => field.onChange(selected)}
                                    />
                                  )}
                                />
                                {errors.primary_skills && (
                                  <small className="text-danger text-sm">
                                    {errors.primary_skills.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label
                                  htmlFor="secondary_skills"
                                  className="block mb-2"
                                >
                                  Secondary Skills
                                </label>
                              </Col>
                              <Col xl={9}>
                                {/* <Dropdown
                                                    value={secondarySkills}
                                                    onChange={(e) => setSecondarySkills(e.value)}
                                                    options={primarySkillsget}
                                                    optionLabel="name"
                                                    placeholder="Typescript"
                                                    className="w-full"
                                                    filter
                                                    editable
                                                    itemTemplate={skillOptionTemplate}
                                                  /> */}

                                <Controller
                                  name="secondary_skills"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      isMulti
                                      options={primarySkillsget}
                                      getOptionLabel={e => e.name}
                                      getOptionValue={e => e.id}
                                      className="w-full"
                                      placeholder="Javascript, React"
                                      value={field.value || []}
                                      onChange={selected => field.onChange(selected)}
                                    />
                                  )}
                                />
                                {errors.secondary_skills && (
                                  <small className="text-danger text-sm">
                                    {errors.secondary_skills.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label htmlFor="other" className="block mb-2">
                                  Other Skills
                                </label>
                              </Col>
                              <Col xl={9}>
                                {/* <Dropdown
                                                    value={otherSkills}
                                                    onChange={(e) => setOtherSkills(e.value)}
                                                    options={primarySkillsget}
                                                    optionLabel="name"
                                                    placeholder="Python, Django"
                                                    className="w-full"
                                                    filter
                                                    editable
                                                    itemTemplate={skillOptionTemplate}
                                                  /> */}

                                <Controller
                                  name="other_skills"
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      isMulti
                                      options={primarySkillsget}
                                      getOptionLabel={e => e.name}
                                      getOptionValue={e => e.id}
                                      className="w-full"
                                      placeholder="Javascript, React"
                                      value={field.value || []}
                                      onChange={selected => field.onChange(selected)}
                                    />
                                  )}
                                />
                                {errors.other_skills && (
                                  <small className="text-danger text-sm">
                                    {errors.other_skills.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xl={4}>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">General Information</h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label
                                  htmlFor="currentSalary"
                                  className="block mb-2"
                                >
                                  Current Salary
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="current_salary"
                                  control={control}
                                  // rules={{ required: "Current salary is required" }}
                                  render={({ field, fieldState }) => (
                                    <>
                                      <InputNumber
                                        inputId="current_salary"
                                        mode="currency"
                                        currency="INR"
                                        locale="en-IN"
                                        placeholder="Enter current annual salary"
                                        className={`w-full ${
                                          fieldState.invalid ? "p-invalid" : ""
                                        }`}
                                        value={field.value}
                                        onValueChange={e =>
                                          field.onChange(e.value)
                                        } // IMPORTANT: use e.value here
                                        useGrouping
                                        min={0}
                                      />
                                      {fieldState.error && (
                                        <small className="text-danger">
                                          {fieldState.error.message}
                                        </small>
                                      )}
                                    </>
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label
                                  htmlFor="expectedSalary"
                                  className="block mb-2"
                                >
                                  Expected Salary
                                </label>
                              </Col>
                              <Col xl={9}>
                                {/* <InputNumber
                                                  inputId="expectedSalary"
                                                  value={expectedSalary}
                                                  onValueChange={(e) => setExpectedSalary(e.value)}
                                                  mode="currency"
                                                  currency="INR"
                                                  locale="en-IN"
                                                  placeholder="Enter expected  annual salary"
                                                  className="w-full" /> */}
                                <Controller
                                  name="expected_salary"
                                  control={control}
                                  render={({ field }) => (
                                    <div className="mb-3">
                                      <InputNumber
                                        value={field.value}
                                        onChange={e => field.onChange(e.value)} // extract the actual number
                                        inputId="expected_salary"
                                        mode="currency"
                                        currency="INR"
                                        locale="en-IN"
                                        placeholder="Enter expected annual salary"
                                        className="w-full"
                                        min={0}
                                      />
                                      {errors.expected_salary && (
                                        <small className="text-danger">
                                          {errors.expected_salary.message}
                                        </small>
                                      )}
                                    </div>
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label
                                  htmlFor="employeeType"
                                  className="block mb-2"
                                >
                                  Employee Type
                                </label>
                              </Col>
                              <Col xl={9}>
                                {/* <div className="card flex justify-content-center mb-0"> */}
                                <select
                                  className="form-select profileDetailsInput"
                                  {...register("employee_type")}
                                >
                                  <option value="">--Select--</option>
                                  {employeeTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                      {type.label}
                                    </option>
                                  ))}
                                </select>

                                {/* </div> */}
                                {errors.employee_type && (
                                  <small className="text-danger">
                                    {errors.employee_type.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Date of Birth
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="dob"
                                  control={control}
                                  render={({ field }) => (
                                    <Calendar
                                      value={field.value}
                                      onChange={e => {
                                        field.onChange(e.value)
                                        trigger("dob") // Trigger validation on change
                                      }}
                                      dateFormat="yy-mm-dd"
                                      showIcon
                                      className="w-full"
                                      icon="pi pi-calendar" // <-- explicitly add icon class
                                    />
                                  )}
                                />
                                {errors.dob && (
                                  <small className="text-danger">
                                    {errors.dob.message}
                                  </small>
                                )}
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Availability Date
                                </label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="availability_date"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <Calendar
                                      value={value}
                                      onChange={e => onChange(e.value)}
                                      dateFormat="yy-mm-dd" // Changed format to YYYY-MM-DD
                                      showIcon
                                      icon="pi pi-calendar" // <-- explicitly add icon class
                                      className="w-full"
                                      minDate={new Date()}
                                    />
                                  )}
                                />
                                {errors.availability_date && (
                                  <small className="text-danger">
                                    {errors.availability_date.message}
                                  </small>
                                )}
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2" htmlFor="source">
                                  Source
                                </label>
                              </Col>

                              <Col xl={9}>
                                {/* <Controller
                                    name="source"
                                    className="w-full"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                      <>
                                        <Dropdown
                                          {...field}
                                          value={field.value}
                                          onChange={e =>
                                            field.onChange(e.value)
                                          } // 👈 only ID will go to payload
                                          options={sourceOptions}
                                          optionLabel="label"
                                          placeholder="Select Source"
                                          className={`w-full activejobdrop ${fieldState.invalid
                                              ? "p-invalid"
                                              : ""
                                            }`}
                                        />
                                        {fieldState.error && (
                                          <small className="p-error">
                                            {fieldState.error.message}
                                          </small>
                                        )}
                                      </>
                                    )}
                                  /> */}
                                <Controller
                                  name="source"
                                  control={control}
                                  render={({ field }) => (
                                    <select
                                      {...field}
                                      className="form-select w-100"
                                    >
                                      <option value="">Select Source</option>
                                      {sourceOptions.map((option, index) => (
                                        <option
                                          key={index}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Referred By
                                </label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  className="w-full"
                                  placeholder="Referred By"
                                  {...register("referred_by")}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Categories
                                </label>
                              </Col>
                              <Col xl={9}>
                                {/* <Dropdown
                                                  value={selectedCategoryKey}
                                                  onChange={handleCategoryChange}
                                                  options={categoriesitem}
                                                  filter
                                                  optionLabel="name"
                                                  optionValue="id"
                                                  className="w-full"
                                                  placeholder="Select Category" /> */}
                                <TreeSelect
                                  value={selectedCategoryKey}
                                  options={categoriesitem}
                                  onChange={e =>
                                    setSelectedCategoryKey(e.value)
                                  }
                                  className="w-full"
                                  placeholder="Select Category"
                                  filter
                                />
                              </Col>
                            </Row>

                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">Groups</label>
                              </Col>
                              <Col xl={9}>
                                {/* <Dropdown
                                  value={selectedGroupKey}
                                  onChange={e => setSelectedGroupKey(e.value)}
                                  options={groupitem}
                                  optionLabel="name"
                                  optionValue="id"
                                  filter
                                  className="w-full"
                                  placeholder="Select Group"
                                /> */}
                                <TreeSelect
                                  value={selectedGroupKey}
                                  options={groupitem}
                                  onChange={e => setSelectedGroupKey(e.value)}
                                  className="w-full"
                                  placeholder="Select Group"
                                  filter
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={4}></Col>
                              <Col lg={4}>
                                <Row className="mt-2 align-items-center">
                                  <Col xl={12}>
                                    <Controller
                                      name="relocation"
                                      control={control}
                                      render={({ field }) => (
                                        <div className="flex align-items-center">
                                          <Checkbox
                                            inputId="relocation"
                                            onChange={e =>
                                              field.onChange(e.checked)
                                            }
                                            checked={field.value}
                                            className="me-2"
                                          />
                                          <label
                                            htmlFor="relocation"
                                            className="mb-0"
                                          >
                                            Relocation
                                          </label>
                                        </div>
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col lg={4}>
                                <Row className="mt-2 align-items-center">
                                  <Col xl={12}>
                                    <Controller
                                      name="private"
                                      control={control}
                                      render={({ field }) => (
                                        <div className="flex align-items-center">
                                          <Checkbox
                                            inputId="private"
                                            onChange={e =>
                                              field.onChange(e.checked)
                                            }
                                            checked={field.value}
                                            className="me-2"
                                          />
                                          <label
                                            htmlFor="private"
                                            className="mb-0"
                                          >
                                            Private
                                          </label>
                                        </div>
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Resume </h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block mb-2">
                                  Resume Attachment
                                </label>
                              </Col>
                              <Col xl={9}>
                                <div style={{ position: "relative" }}>
                                  <input
                                    type="file"
                                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    className="form-control addEmp_ProfilePhoto"
                                    id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                                    onChange={handleFileChange}
                                  />
                                  {fileData?.name && (
                                    <i
                                      className="pi pi-times"
                                      style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#ff0000",
                                      }}
                                      onClick={handleRemoveFile}
                                    ></i>
                                  )}
                                </div>
                                {error && (
                                  <small className="text-danger">{error}</small>
                                )}
                                {/* Show existing file with download link if available */}
                                {fileData?.name && (
                                  <div className="mt-2">
                                    {fileData?.base64?.startsWith("http") ? (
                                      <a
                                        href={fileData.base64}
                                        download={fileData.name}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-primary"
                                      >
                                        📄 {fileData.name}
                                      </a>
                                    ) : (
                                      <span className="text-dark">
                                        📄 {fileData.name}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Documents</h4>
                  <Row>
                    <Col xl={12}>
                      <div>
                        <Row className="mt-2">
                          <Col xl={12}>
                            <DataTable
                              value={documents}
                              rows={5}
                              className="p-datatable-gridlines"
                              emptyMessage={
                                <div className="empty-message-custom">
                                  No documents found.
                                </div>
                              }
                            >
                              <Column field="selected_document" header="Type" />
                              <Column field="subject" header="Subject" />
                              <Column
                                field="file.name"
                                header="Attachment"
                                body={rowData =>
                                  rowData.file?.name || "No file"
                                }
                              />
                            </DataTable>
                          </Col>
                        </Row>
                        <div className="block d-flex justify-content-end align-items-center">
                          <a
                            color="primary"
                            className="anchr-title  mt-3"
                            onClick={openAddDocumentDialog}
                          >
                            <i className="pi pi-plus me-1"></i> Add More
                          </a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>

                <Dialog
                  header="Add Document"
                  visible={displayDialog}
                  onHide={closeAddDocumentDialog}
                  style={{ width: "30vw" }}
                >
                  <form
                    onSubmit={handleSubmitDoc(data => {
                      setDocuments([...documents, data])
                      resetDocForm() // clear dialog form
                      closeAddDocumentDialog()
                    })}
                  >
                    <Row className="mt-2 align-items-center">
                      <Col xl={3}>
                        <label className="block mb-2">Type</label>
                      </Col>
                      <Col xl={9}>
                        <Controller
                          name="selected_document"
                          control={controlDoc}
                          rules={{ required: "Document type is required *" }}
                          render={({ field, fieldState }) => (
                            <>
                              <Dropdown
                                {...field}
                                value={field.value}
                                onChange={e => field.onChange(e.value)}
                                options={documentTypes}
                                optionLabel="label"
                                optionGroupLabel="label"
                                optionGroupChildren="items"
                                optionGroupTemplate={groupedItemTemplate}
                                className={`w-full bgclr ${
                                  fieldState.invalid ? "p-invalid" : ""
                                }`}
                                placeholder="Select a Document"
                              />
                              {fieldState.error && (
                                <small className="p-error">
                                  {fieldState.error.message}
                                </small>
                              )}
                            </>
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                      <Col xl={3}>
                        <label className="block mb-2">Subject</label>
                      </Col>
                      <Col xl={9}>
                        <InputText
                          className="w-full"
                          {...registerDoc("subject", {
                            required: "Subject is required *",
                            maxLength: {
                              value: 100,
                              message: "Subject cannot exceed 100 characters",
                            },
                          })}
                          onKeyUp={() => trigger("subject")}
                        />
                        {errorsDoc.subject && (
                          <small className="p-error">
                            {errorsDoc.subject.message}
                          </small>
                        )}
                      </Col>
                    </Row>

                    <Row className="mt-2 align-items-center">
                      <Col xl={3}>
                        <label className="block mb-2">Attachment</label>
                      </Col>
                      <Col xl={9}>
                        <Controller
                          name="file"
                          control={controlDoc}
                          rules={{
                            required: "File attachment is required",
                            validate: {
                              validFileType: value =>
                                (value &&
                                  [
                                    "application/pdf",
                                    "application/msword",
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                  ].includes(value.type)) ||
                                "Only PDF, Word documents, and image files (jpg, jpeg, png) are allowed",
                              maxSize: value =>
                                (value && value.size <= 5 * 1024 * 1024) ||
                                "File size should not exceed 5MB",
                            },
                          }}
                          render={({ field }) => (
                            <FileUpload
                              customUpload
                              mode="basic"
                              accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/jpg,image/png"
                              maxFileSize={5 * 1024 * 1024}
                              chooseLabel="Choose"
                              uploadLabel="Upload"
                              cancelLabel="Cancel"
                              onSelect={async e => {
                                const file = e.files[0]
                                if (!file) return
                                const base64 = await getBase64(file)
                                field.onChange({
                                  name: file.name,
                                  base64,
                                  type: file.type,
                                  size: file.size,
                                })
                              }}
                            />
                          )}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={12}>
                        <div className="d-flex justify-content-end mt-2">
                          <Button
                            color="primary btn-main mr-2"
                            type="submit"
                            disabled={Object.keys(errorsDoc).length > 0}
                          >
                            Ok
                          </Button>
                          <Button
                            type="button"
                            color="secondary"
                            className="btn waves-effect waves-light ml-2"
                            onClick={closeAddDocumentDialog}
                          >
                            Cancel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </Dialog>
              </Card>
            </Col>

            <Col xl={4}>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-3">Work Experience</h4>
                  {/* <DataTable value={workExperiences} responsiveLayout="scroll" className="mt-2"
                        emptyMessage={<div className="empty-message-custom">No education details found.</div>}>
                        <Column field="company_name" header="Company" />
                        <Column field="job_title" header="Job Title" />
                        <Column field="start_date" header="From Date" body={(rowData) => rowData.start_date ? new Date(rowData.start_date).toLocaleDateString() : ''} />
                        <Column field="end_date" header="To Date" body={(rowData) => rowData.end_date ? new Date(rowData.end_date).toLocaleDateString() : ''} />
                      </DataTable> */}
                  <DataTable
                    value={workExperiences}
                    responsiveLayout="scroll"
                    className="mt-2"
                    emptyMessage={
                      <div className="empty-message-custom">
                        No work experience found.
                      </div>
                    }
                  >
                    <Column field="company_name" header="Company" />
                    <Column field="job_title" header="Job Title" />
                    <Column
                      field="start_date"
                      header="From Date"
                      body={rowData =>
      rowData.start_date ? new Date(rowData.start_date).toISOString().split('T')[0] : "-"
    }
                    />
                    <Column
                      field="end_date"
                      header="To Date"
                      body={rowData =>
      rowData.end_date === "Present"
        ? "Present"
        : rowData.end_date ? new Date(rowData.end_date).toISOString().split('T')[0] : "-"
    }
                    />
                    <Column
                      header="Actions"
                      body={(rowData, { rowIndex }) => (
                        <div>
                          <i className="pi pi-pencil me-2" style={{ cursor: 'pointer' }} onClick={() => { setEditIndex(rowIndex); resetWork(workExperiences[rowIndex]); setShowDialog(true); }}></i>
                          <i className="pi pi-trash" style={{ cursor: 'pointer' }} onClick={() => { setWorkToDelete(rowIndex); setDeleteWorkVisible(true); }}></i>
                        </div>
                      )}
                    />
                  </DataTable>

                  <div className="block d-flex align-items-center justify-content-end">
                    <a
                      color="primary"
                      className="anchr-title  mt-3"
                      onClick={() => {
                        setShowDialog(true)
                        setFormValues([])
                      }}
                    >
                      <i className="pi pi-plus me-1"></i> Add More
                    </a>
                  </div>
                  <Dialog
                    header={
                      editIndex !== null
                        ? "Edit Work Experience"
                        : "Add Work Experience"
                    }
                    visible={showDialog}
                    style={{ width: "30vw" }}
                    onHide={() => {
                      setShowDialog(false)
                      resetWork()
                    }}
                  >
                    <form
                      onSubmit={handleSubmitWork(data => {
                        if (editIndex !== null) {
                          const updated = [...workExperiences]
                          updated[editIndex] = data
                          setWorkExperiences(updated)
                          triggerAlert("success", "Success", "Work experience updated successfully.")
                        } else {
                          setWorkExperiences([...workExperiences, data])
                          triggerAlert("success", "Success", "Work experience added successfully.")
                        }
                        resetWork()
                        setShowDialog(false)
                        setEditIndex(null)
                      })}
                    >
                      <Row className="mb-2">
                        <Col xl={12}>
                          <label htmlFor="company" className="block">
                            Company
                          </label>
                          <InputText
                            className="w-full"
                            {...registerWork("company_name", {
                              required: "Company name is required *",
                              maxLength: {
                                value: 100,
                                message:
                                  "Company name cannot exceed 100 characters",
                              },
                              pattern: {
                                value: /^[A-Za-z][A-Za-z0-9\s\-&.]+$/,
                                message:
                                  "Company name must start with a letter and contain only letters, numbers, spaces, hyphens, or ampersands",
                              },
                            })}
                            onKeyUp={() => trigger("company_name")}
                          />
                          {errorsWork.company_name && (
                            <small className="p-error">
                              {errorsWork.company_name.message}
                            </small>
                          )}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col xl={12}>
                          <label htmlFor="website" className="block">
                            Website
                          </label>
                          <InputText
                            className="w-full"
                            {...registerWork("website", {
                              required: "Website is required *",
                              pattern: {
                                value:
                                  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                                message: "Please enter a valid URL",
                              },
                            })}
                            onKeyUp={() => trigger("website")}
                          />
                          {errorsWork.website && (
                            <small className="p-error">
                              {errorsWork.website.message}
                            </small>
                          )}
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xl={12}>
                          <label htmlFor="jobTitle" className="block">
                            Job Title
                          </label>
                          <InputText
                            className="w-full"
                            {...registerWork("job_title", {
                              required: "Job title is required *",
                              maxLength: {
                                value: 100,
                                message:
                                  "Job title cannot exceed 100 characters",
                              },
                              pattern: {
                                value: /^[A-Za-z][A-Za-z0-9\s\-&]+$/,
                                message:
                                  "Job title must start with a letter and contain only letters, numbers, spaces, or hyphens",
                              },
                            })}
                            onKeyUp={() => trigger("job_title")}
                          />
                          {errorsWork.job_title && (
                            <small className="p-error">
                              {errorsWork.job_title.message}
                            </small>
                          )}
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xl={12}>
                          <label htmlFor="fromDate" className="block">
                            From Date
                          </label>
                          <Controller
                            name="start_date"
                            control={controlWork}
                            rules={{
                              required: "Start date is required *",
                              validate: value => {
                                const today = new Date()
                                return (
                                  value <= today ||
                                  "Start date cannot be in the future"
                                )
                              },
                            }}
                            render={({ field, fieldState }) => (
                              <>
                                <Calendar
                                  {...field}
                                  showIcon
                                  icon="pi pi-calendar" // <-- explicitly add icon class
                                  className={`w-full ${
                                    fieldState.invalid ? "p-invalid" : ""
                                  }`}
                                  dateFormat="yy-mm-dd"
                                />
                                {fieldState.error && (
                                  <small className="p-error">
                                    {fieldState.error.message}
                                  </small>
                                )}
                              </>
                            )}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xl={12}>
                          <label htmlFor="toDate" className="block">
                            To Date
                          </label>
                          <Controller
                            name="end_date"
                            control={controlWork}
                            rules={{
                              required: "End date is required *",
                              validate: {
                                notBeforeStart: value => {
                                  const startDate = getValues("start_date")
                                  return (
                                    !startDate ||
                                    !value ||
                                    value >= startDate ||
                                    "End date cannot be before start date"
                                  )
                                },
                              },
                            }}
                            render={({ field, fieldState }) => (
                              <>
                                <Calendar
                                  {...field}
                                  showIcon
                                  icon="pi pi-calendar" // <-- explicitly add icon class
                                  className={`w-full ${
                                    fieldState.invalid ? "p-invalid" : ""
                                  }`}
                                  dateFormat="yy-mm-dd"
                                />
                                {fieldState.error && (
                                  <small className="p-error">
                                    {fieldState.error.message}
                                  </small>
                                )}
                              </>
                            )}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12}>
                          <div className="d-flex justify-content-end mt-2">
                            <Button
                              type="submit"
                              color="primary btn-main mr-2"
                              disabled={Object.keys(errorsWork).length > 0}
                            >
                              {editIndex !== null ? "Update" : "Ok"}
                            </Button>
                            <Button
                              type="button"
                              color="secondary"
                              className="btn waves-effect waves-light ml-2"
                              onClick={() => {
                                setShowDialog(false)
                                resetWork()
                              }}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </Dialog>
                  <ConfirmDialog
                    visible={deleteWorkVisible}
                    onHide={() => setDeleteWorkVisible(false)}
                    message="Do you want to delete this work experience?"
                    header="Confirm Delete"
                    accept={() => {
                      const updated = workExperiences.filter((_, i) => i !== workToDelete);
                      setWorkExperiences(updated);
                      setDeleteWorkVisible(false);
                    }}
                    reject={() => setDeleteWorkVisible(false)}
                  />
                  <ConfirmDialog />
                </CardBody>
              </Card>

              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-3">Education Details</h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <DataTable
                              value={educationDetails}
                              showGridlines
                              emptyMessage={
                                <div className="empty-message-custom">
                                  No education details found.
                                </div>
                              }
                            >
                              <Column field="degree" header="Degree" />
                              <Column field="school_name" header="School" />
                              <Column
                                field="field_of_study"
                                header="Field of Study"
                              />
                              {/* <Column field="grade" header="Grade" />
                              <Column field="start_year" header="Start Year" />
                              <Column
                                field="start_month"
                                header="Start Month"
                              /> */}
                              <Column field="end_year" header="End Year" />
                              {/* <Column field="end_month" header="End Month" /> */}
                              <Column
                                header="Actions"
                                body={(rowData, { rowIndex }) => (
                                  <div>
                                    <i className="pi pi-pencil me-2" style={{ cursor: 'pointer' }} onClick={() => { setEditEduIndex(rowIndex); resetEduForm(educationDetails[rowIndex]); setIsDialogVisible(true); }}></i>
                                    <i className="pi pi-trash" style={{ cursor: 'pointer' }} onClick={() => { setEduToDelete(rowIndex); setDeleteEduVisible(true); }}></i>
                                  </div>
                                )}
                              />
                            </DataTable>
                            <div className="block d-flex align-items-center justify-content-end">
                              <a
                                color="primary"
                                className="anchr-title mt-3"
                                onClick={() => { setEditEduIndex(null); setIsDialogVisible(true); }}
                              >
                                <i className="pi pi-plus me-1"></i> Add More
                              </a>
                            </div>

                            <Dialog
                              header={editEduIndex !== null ? "Edit Education" : "Add Education"}
                              visible={isDialogVisible}
                              style={{ width: "30vw" }}
                              onHide={() => { setIsDialogVisible(false); setEditEduIndex(null); }}
                            >
                              <form
                                onSubmit={handleSubmitEdu(data => {
                                  if (editEduIndex !== null) {
                                    const updated = [...educationDetails]
                                    updated[editEduIndex] = data
                                    setEducationDetails(updated)
                                    triggerAlert("success", "Success", "Education detail updated successfully.")
                                  } else {
                                    setEducationDetails(prev => [...prev, data])
                                    triggerAlert("success", "Success", "Education detail added successfully.")
                                  }
                                  resetEduForm() // reset modal form
                                  setIsDialogVisible(false)
                                  setEditEduIndex(null)
                                })}
                              >
                                <div className="field">
                                  <label className="block mb-2">Degree</label>
                                  <Controller
                                    name="degree"
                                    control={eduControl}
                                    rules={{
                                      required: "Degree is required *",
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "Degree cannot exceed 100 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z][A-Za-z0-9\s\-&.]+$/,
                                        message:
                                          "Degree must start with a letter and contain only letters, numbers, spaces, or hyphens",
                                      },
                                    }}
                                    render={({ field, fieldState }) => (
                                      <>
                                        <InputText
                                          {...field}
                                          placeholder="Enter Degree"
                                          className={`w-full ${
                                            fieldState.invalid
                                              ? "p-invalid"
                                              : ""
                                          }`}
                                        />
                                        {fieldState.error && (
                                          <small className="p-error">
                                            {fieldState.error.message}
                                          </small>
                                        )}
                                      </>
                                    )}
                                  />
                                </div>

                                <div className="field mt-2">
                                  <label className="block mb-2">School</label>
                                  <Controller
                                    name="school_name"
                                    control={eduControl}
                                    rules={{
                                      required: "School is required *",
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "School name cannot exceed 100 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z][A-Za-z0-9\s\-&.]+$/,
                                        message:
                                          "School name must start with a letter and contain only letters, numbers, spaces, or hyphens",
                                      },
                                    }}
                                    render={({ field, fieldState }) => (
                                      <>
                                        <InputText
                                          {...field}
                                          placeholder="Enter School"
                                          className={`w-full ${
                                            fieldState.invalid
                                              ? "p-invalid"
                                              : ""
                                          }`}
                                        />
                                        {fieldState.error && (
                                          <small className="p-error">
                                            {fieldState.error.message}
                                          </small>
                                        )}
                                      </>
                                    )}
                                  />
                                </div>

                                <div className="field mt-2">
                                  <label className="block mb-2">
                                    Field of Study
                                  </label>
                                  <Controller
                                    name="field_of_study"
                                    control={eduControl}
                                    rules={{
                                      required: "Field of study is required *",
                                      maxLength: {
                                        value: 100,
                                        message:
                                          "Field of study cannot exceed 100 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z][A-Za-z0-9\s\-&.]+$/,
                                        message:
                                          "Field of study must start with a letter and contain only letters, numbers, spaces, or hyphens",
                                      },
                                    }}
                                    render={({ field, fieldState }) => (
                                      <>
                                        <InputText
                                          {...field}
                                          placeholder="Enter Field of Study"
                                          className={`w-full ${
                                            fieldState.invalid
                                              ? "p-invalid"
                                              : ""
                                          }`}
                                        />
                                        {fieldState.error && (
                                          <small className="p-error">
                                            {fieldState.error.message}
                                          </small>
                                        )}
                                      </>
                                    )}
                                  />
                                </div>

                                <div className="field mt-2">
                                  <label className="block mb-2">Grade</label>
                                  <Controller
                                    name="grade"
                                    control={eduControl}
                                    rules={{
                                      required: "Grade is required *",
                                      maxLength: {
                                        value: 10,
                                        message:
                                          "Grade cannot exceed 10 characters",
                                      },
                                      pattern: {
                                        value: /^[A-Za-z0-9\s\-+.]+$/,
                                        message:
                                          "Grade must contain only letters, numbers, or hyphens",
                                      },
                                    }}
                                    render={({ field, fieldState }) => (
                                      <>
                                        <InputText
                                          {...field}
                                          placeholder="Enter Grade"
                                          className={`w-full ${
                                            fieldState.invalid
                                              ? "p-invalid"
                                              : ""
                                          }`}
                                        />
                                        {fieldState.error && (
                                          <small className="p-error">
                                            {fieldState.error.message}
                                          </small>
                                        )}
                                      </>
                                    )}
                                  />
                                </div>

                                <Row className="mt-2">
                                  <Col xl={6}>
                                    <label className="block mb-2">
                                      Start Year{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Controller
                                      name="start_year"
                                      control={eduControl}
                                      rules={{
                                        required: "Start year is required",
                                      }}
                                      render={({ field }) => (
                                        <Dropdown
                                          {...field}
                                          options={years}
                                          placeholder="Select Year"
                                          className="w-full"
                                        />
                                      )}
                                    />
                                    {eduErrors.start_year && (
                                      <small className="p-error">
                                        {eduErrors.start_year.message}
                                      </small>
                                    )}
                                  </Col>
                                  <Col xl={6}>
                                    <label className="block mb-2">
                                      Start Month{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Controller
                                      name="start_month"
                                      control={eduControl}
                                      rules={{
                                        required: "Start month is required",
                                      }}
                                      render={({ field }) => (
                                        <Dropdown
                                          {...field}
                                          options={months}
                                          placeholder="Select Month"
                                          className="w-full"
                                        />
                                      )}
                                    />
                                    {eduErrors.start_month && (
                                      <small className="p-error">
                                        {eduErrors.start_month.message}
                                      </small>
                                    )}
                                  </Col>
                                </Row>
                                <Row className="mt-2">
                                  <Col xl={6}>
                                    <label className="block mb-2">
                                      End Year{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Controller
                                      name="end_year"
                                      control={eduControl}
                                      rules={{
                                        required: "End year is required",
                                        validate: value => {
                                          const startYear =
                                            watchEdu("start_year") // ✅ Get start year
                                          if (startYear && value < startYear) {
                                            return "End year cannot be less than start year"
                                          }
                                          return true
                                        },
                                      }}
                                      render={({ field }) => (
                                        <Dropdown
                                          {...field}
                                          options={years}
                                          placeholder="Select Year"
                                          className="w-full"
                                        />
                                      )}
                                    />
                                    {eduErrors.end_year && (
                                      <small className="p-error">
                                        {eduErrors.end_year.message}
                                      </small>
                                    )}
                                  </Col>
                                  <Col xl={6}>
                                    <label className="block mb-2">
                                      End Month{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Controller
                                      name="end_month"
                                      control={eduControl}
                                      rules={{
                                        required: "End month is required",
                                      }}
                                      render={({ field }) => (
                                        <Dropdown
                                          {...field}
                                          options={months}
                                          placeholder="Select Month"
                                          className="w-full"
                                        />
                                      )}
                                    />
                                    {eduErrors.end_month && (
                                      <small className="p-error">
                                        {eduErrors.end_month.message}
                                      </small>
                                    )}
                                  </Col>
                                </Row>

                                <Row>
                                  <Col xl={12}>
                                    <div className="d-flex justify-content-end mt-2">
                                      <Button
                                        color="primary btn-main mr-2"
                                        type="submit"
                                        disabled={
                                          Object.keys(eduErrors).length > 0
                                        }
                                      >
                                        {editEduIndex !== null ? "Update" : "Ok"}
                                      </Button>
                                      <Button
                                        type="button"
                                        color="secondary"
                                        className="btn waves-effect waves-light ml-2"
                                        onClick={() =>
                                          setIsDialogVisible(false)
                                        }
                                      >
                                        Cancel
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              </form>
                            </Dialog>
                            <ConfirmDialog
                              visible={deleteEduVisible}
                              onHide={() => setDeleteEduVisible(false)}
                              message="Do you want to delete this education detail?"
                              header="Confirm Delete"
                              accept={() => {
                                const updated = educationDetails.filter((_, i) => i !== eduToDelete);
                                setEducationDetails(updated);
                                setDeleteEduVisible(false);
                              }}
                              reject={() => setDeleteEduVisible(false)}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">Social Pages</h4>
                  <Row>
                    <Col xl={12}>
                      <Row className="align-items-center mt-2">
                        <Col xl={3}>
                          <label className="block">LinkedIn URL</label>
                        </Col>
                        <Col xl={9} style={{ position: "relative" }}>
                          <InputText
                            className="w-full"
                            {...register(
                              "linkedin_url"
                              // , { required: "LinkedIn URL is required" }
                            )}
                          />
                          <i
                            className="pi pi-linkedin linkd-icon"
                            style={{
                              position: "absolute",
                              right: "22px",
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                          {errors.linkedin_url && (
                            <small className="p-error">
                              {errors.linkedin_url.message}
                            </small>
                          )}
                        </Col>
                      </Row>

                      <Row className="mt-2 align-items-center">
                        <Col xl={3}>
                          <label className="block">Facebook URL</label>
                        </Col>
                        <Col xl={9} style={{ position: "relative" }}>
                          <InputText
                            className="w-full"
                            {...register(
                              "facebook_url"
                              // , { required: "Facebook URL is required" }
                            )}
                          />
                          <i
                            className="pi pi-facebook facebook-icon"
                            style={{
                              position: "absolute",
                              right: "22px",
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                          {errors.facebook_url && (
                            <small className="p-error">
                              {errors.facebook_url.message}
                            </small>
                          )}
                        </Col>
                      </Row>

                      <Row className="mt-2 align-items-center">
                        <Col xl={3}>
                          <label className="block">Twitter URL</label>
                        </Col>
                        <Col xl={9} style={{ position: "relative" }}>
                          <InputText
                            className="w-full"
                            {...register(
                              "x_url"
                              // , { required: "Twitter (X) URL is required" }
                            )}
                          />
                          <i
                            className="pi pi-twitter twitter-icon"
                            style={{
                              position: "absolute",
                              right: "22px",
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                          {errors.x_url && (
                            <small className="p-error">
                              {errors.x_url.message}
                            </small>
                          )}
                        </Col>
                      </Row>

                      <Row className="mt-2 align-items-center">
                        <Col xl={3}>
                          <label className="block">Indeed URL</label>
                        </Col>
                        <Col xl={9} style={{ position: "relative" }}>
                          <InputText
                            className="w-full"
                            {...register(
                              "indeed_url"
                              // , { required: "Indeed URL is required" }
                            )}
                          />
                          <i
                            className="pi pi-info indeed-icon"
                            style={{
                              position: "absolute",
                              right: "22px",
                              top: "50%",
                              transform: "translateY(-50%)",
                            }}
                          ></i>
                          {errors.indeed_url && (
                            <small className="p-error">
                              {errors.indeed_url.message}
                            </small>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card className="bg-form">
                <CardBody>
                  <h4 className="card-title mb-2">System Fields</h4>
                  <Row>
                    <Col xl={12}>
                      <div className="">
                        <Row>
                          <Col xl={12}>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block">Create Date</label>
                              </Col>
                              <Col xl={9}>
                                <Controller
                                  name="created_at"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <Calendar
                                      // showTime
                                      value={value}
                                      onChange={e => onChange(e.value)}
                                      dateFormat="yy-mm-dd"
                                      // hourFormat="24"
                                      showIcon
                                      icon="pi pi-calendar" // <-- explicitly add icon class
                                      className="w-full"
                                      disabled
                                    />
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className="block">Edit Date</label>
                              </Col>

                              <Col xl={9}>
                                <Controller
                                  name="updated_at"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <Calendar
                                      // showTime
                                      value={value}
                                      onChange={e => onChange(e.value)}
                                      dateFormat="yy-mm-dd"
                                      // hourFormat="24"
                                      showIcon
                                      icon="pi pi-calendar" // <-- explicitly add icon class
                                      className="w-full"
                                      disabled
                                    />
                                  )}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block">Created By</label>
                              </Col>
                              <Col xl={9}>
                                <InputText
                                  disabled
                                  className="w-full"
                                  {...register("created_by")}
                                  value={uniqueUserId}
                                />
                              </Col>
                            </Row>
                            {/* <Row className="mt-2 align-items-center">
                                              <Col xl={3}>
                                                <label className=" block">Last Activity Type</label>
                                              </Col>
                                              <Col xl={9}>
                                                <InputText id="integer"
                                                  keyfilter="int" className="w-full"
                                                  {...register("last_activity_type", {})}
                                                   />
                                              </Col>
                                            </Row> */}
                            {/* <Row className="mt-2 align-items-center">
                              <Col xl={3}>
                                <label className=" block">
                                  Last Activity Date
                                </label>
                              </Col>

                              <Col xl={9}>
                                <Controller
                                  name="last_activity_date"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <Calendar
                                      showTime
                                      value={value}
                                      onChange={e => onChange(e.value)}
                                      dateFormat="yy-mm-dd"
                                      hourFormat="24"
                                      showIcon
                                      icon="pi pi-calendar" // <-- explicitly add icon class
                                      className="w-full"
                                      disabled
                                    />
                                  )}
                                />
                              </Col>
                            </Row> */}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="align-items-center mb-3">
            <Col md={12}>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn-success me-2"
                  onClick={handleSubmit(onSubmit)}
                  disabled={isLoading}
                >
                  {" "}
                  <i class="pi pi-save me-1"></i>{" "}
                  {isLoading ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  class="btn btn-primary me-2 cancel-outlinebtn btn btn-primary"
                  onClick={() => {
                    navigate("/allactive-candidates")
                  }}
                >
                  <i class="pi pi-times me-1"></i>Cancel
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UploadResumeForm
